export default {
  title: 'Delete ',
  description: 'Are you sure you want to delete this Media?',
  deleteButton: 'Delete',
  cancelButton: 'Cancel',
};
